import { data } from "autoprefixer";
import axios from "axios";

export const urlBase = process.env.REACT_APP_API_URL;

const urlChat = `${urlBase}/public/v2/fe/`;

const authHeaders = {
  Authorization: "Basic xxxxxxxxxxxxx",
  "Content-Type": "application/json;charset=UTF-8",
};

const getConversation = async ({channelId, visitorId}) => {
    try {
        const res = await axios.get(`${urlChat}${channelId}/conversations`, {
        params: {
          id: visitorId,
          page: 0,
          size: 20,
        },
        headers: authHeaders,
    });
    return res.data;
    
    } catch (error) {
    }
}

const createConversation = async (channelId, visitorId) => {
  try {
    const res = await axios.post(
      `${urlChat}createConversation`,
      {
        channelId: channelId,
        id: visitorId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return res.data; 
  } catch (err) {
    console.error("Tạo conversation thất bại:", err);
    throw err;
  }
};

const deleteConversation = async (conversationId) => {
  try {
    const res = await axios.delete(`${urlChat}conversations/${conversationId}`)
    return res.data;
  } catch (err) {
    console.error("deleteConversation thất bại:", err);
    throw err;
  }
}

const editConversationTitle = async (conversationId, newTitle) => {
  try {
    const res = await axios.patch(`${urlChat}conversations/${conversationId}`, 
      data = {
        firstMessage: newTitle
      },
      {
        headers: 'Content-Type: application/json'
      },
    )
    return res.data;
  } catch (error) {
    console.error("editConversationTitle thất bại:", error);
    throw error;
  }
}

const ConversationAPI = {
    getConversation,
    createConversation,
    deleteConversation,
    editConversationTitle
}

export default ConversationAPI